module.exports = __webpack_public_path__ + "static/media/vent-direccio-10.2473380f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/vent-direccio-10.svg
// module id = 201
// module chunks = 0